import { z } from 'zod'

/**
 * The kinds of Housecall Pro job an accepted proposal becomes: one per site
 * per kind of work, as the office keeps its own jobs (see "What is written
 * (phase 4)" in irrigation.md). Mirrors `HcpJobKind` in prisma/schema.prisma.
 */
export const HCP_JOB_KINDS = ['TREES', 'IRRIGATION'] as const

export const hcpJobKindSchema = z.enum(HCP_JOB_KINDS)

export type HcpJobKind = z.infer<typeof hcpJobKindSchema>

export const HCP_JOB_KIND_LABELS: Record<HcpJobKind, string> = {
  TREES: 'Tree job',
  IRRIGATION: 'Irrigation job',
}

/**
 * Where a job created from a proposal stands. Mirrors `HcpJobState` in
 * prisma/schema.prisma: CREATING while the request is out, CREATED once HCP
 * answers with the job, UNCONFIRMED when it did not answer and the job may
 * exist.
 */
export const HCP_JOB_STATES = ['CREATING', 'CREATED', 'UNCONFIRMED'] as const

export const hcpJobStateSchema = z.enum(HCP_JOB_STATES)

export type HcpJobState = z.infer<typeof hcpJobStateSchema>
